<template>
  <div
    class="comp-tab-right"
    :class="{ active: isActived }"
    @click="$emit('tabClicked', 'group')"
  >
    {{ $t("match.group") }}
  </div>
</template>

<script>
export default {
  name: 'tab-right',
  props: {
    isActived: Boolean,
  },
};
</script>

<style lang="scss" src="../scss/comp-tab-right.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompTabRight.vue